<template>
  <ul class="systemparam-ul" v-loading="fullLoading">
    <li class="hm-search">
      <!-- 查询部分 -->
      <el-form :inline="true" :model="searchForm">
        <el-form-item :label="$t('Components.System.SystemParam.Search')">
          <el-input
            v-model="searchForm.inputSearch"
            :placeholder="$t('Components.System.SystemParam.NameCode')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('Components.System.SystemParam.Dataflag')">
          <el-select
            v-model="searchForm.dataflag"
            :placeholder="$t('Components.System.SystemParam.SelectDataflag')"
            clearable
          >
            <el-option
              :label="$t('Components.System.SystemParam.DataflagY')"
              value="true"
            />
            <el-option
              :label="$t('Components.System.SystemParam.DataflagN')"
              value="false"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="buttonVisible.searchButton"
            type="primary"
            @click="queryClick"
            :icon="Search"
            >{{ $t("Components.System.SystemParam.Search1") }}</el-button
          >
          <el-button
            v-if="buttonVisible.resetButton"
            @click="resetClick"
            :icon="RefreshLeft"
            >{{ $t("Components.System.SystemParam.Reset") }}</el-button
          >
        </el-form-item>
      </el-form>
    </li>
    <li class="hm-operate">
      <!-- 操作部分 -->
      <el-button
        v-if="buttonVisible.addButton"
        :style="{ color: 'white' }"
        :icon="Plus"
        :color="ButtonColor.Add"
        @click="
          () => {
            dialogVisible = true;
          }
        "
        >{{ $t("Components.System.SystemParam.Add") }}</el-button
      >
      <el-button
        v-if="buttonVisible.editButton"
        :disabled="!(selectSystemParams && selectSystemParams.length === 1)"
        :style="{ color: 'white' }"
        :icon="Edit"
        :color="ButtonColor.Edit"
        @click="handleEdit(1)"
        >{{ $t("Components.System.SystemParam.Edit") }}</el-button
      >
      <el-button
        v-if="buttonVisible.deleteButton"
        :disabled="!(selectSystemParams && selectSystemParams.length > 0)"
        :style="{ color: 'white' }"
        :icon="Delete"
        :color="ButtonColor.Delete"
        @click="handleDeleteBatch"
        >{{ $t("Components.System.SystemParam.Delete") }}</el-button
      >
      <el-button
        v-if="buttonVisible.exportButton"
        :style="{ color: 'white' }"
        :icon="Download"
        :color="ButtonColor.Export"
        @click="handleExport"
        >{{ $t("Components.System.SystemParam.Export") }}</el-button
      >
    </li>
    <el-scrollbar>
      <li class="hm-table">
        <!-- 表格部分 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          row-key="guid"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column
            prop="name"
            min-width="120"
            :label="$t('Components.System.SystemParam.Name')"
          />
          <el-table-column
            prop="code"
            min-width="120"
            :label="$t('Components.System.SystemParam.Code')"
          />
          <el-table-column
            prop="value"
            min-width="120"
            :label="$t('Components.System.SystemParam.Value')"
          />
          <el-table-column
            prop="remark"
            min-width="160"
            show-overflow-tooltip
            :label="$t('Components.System.SystemParam.Remark')"
          />
          <el-table-column
            prop="is_system"
            :label="$t('Components.System.SystemParam.IsSystem')"
          >
            <template #default="scope">
              <el-tag v-if="scope.row.is_system" effect="dark">
                {{ t("Common.YesOrNo.Yes") }}
              </el-tag>
              <el-tag
                v-else
                :style="{ color: 'white' }"
                :color="ButtonColor.DataflagN"
                >{{ t("Common.YesOrNo.No") }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="dataflag"
            :label="$t('Components.System.SystemParam.Dataflag')"
          >
            <template #default="scope">
              <el-switch
                :disabled="!buttonVisible.dataflag"
                v-model="scope.row.dataflag"
                @change="(flag) => handleDataflagChange(flag, scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            sortable
            :label="$t('Components.System.SystemParam.CreateTime')"
          />
          <el-table-column
            :label="$t('Components.System.SystemParam.Operate')"
            width="200"
          >
            <template #default="scope">
              <el-space wrap>
                <el-button
                  v-if="buttonVisible.editButtonLine"
                  :style="{ color: 'white' }"
                  :icon="Edit"
                  :color="ButtonColor.Edit"
                  size="small"
                  @click="handleEdit(2, scope.row)"
                  >{{ $t("Components.System.SystemParam.Edit") }}</el-button
                >
                <el-button
                  v-if="buttonVisible.deleteButtonLine"
                  :style="{ color: 'white' }"
                  :icon="Delete"
                  :color="ButtonColor.Delete"
                  size="small"
                  bg
                  @click="handleDelete(scope.row)"
                  >{{ $t("Components.System.SystemParam.Delete") }}</el-button
                >
              </el-space>
            </template>
          </el-table-column>
        </el-table>
      </li>
    </el-scrollbar>

    <li class="hm-page">
      <el-pagination
      small
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="AllPageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </li>
  </ul>
  <SystemParamModify
    v-if="dialogVisible"
    @handleCloseDialog="handleCloseDialog"
    :editData="editData"
    @getSystemParamPage="getSystemParamPage"
  />
</template>
<script setup>
import { reactive, ref, markRaw, onMounted, watchEffect } from "vue";
import {
  Plus,
  Delete,
  RefreshLeft,
  Edit,
  Search,
  WarnTriangleFilled,
  Download,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import {
  AllPageSize,
  ButtonColor,
  DefaultPageSize,
} from "@/consts/frame";
import {
  request_systemparam_page,
  request_systemparam_delete,
  request_systemparam_delete_batch,
  request_systemparam_dataflag,
  request_systemparam_export,
} from "@/api/apis";
import SystemParamModify from "@/components/System/SystemParam/SystemParamModify.vue";
import { useStore } from "@/store/index";
import { MenuCodes, MenuButtonCodes } from "@/consts/menuAndMenuButtonCode";
import { validateMenuButton } from "@/util/util";

const store = useStore();
const { t } = useI18n();
const searchForm = reactive({
  inputSearch: "",
  dataflag: undefined,
});
const buttonVisible = reactive({
  searchButton: false,
  resetButton: false,
  addButton: false,
  editButton: false,
  deleteButton: false,
  editButtonLine: false,
  deleteButtonLine: false,
  dataflag: false,
  exportButton: false,
});
// 当前页码
const currentPage = ref(1);
// 页码大小
const pageSize = ref(DefaultPageSize);
// 表格数据
const tableData = ref([]);
// 表格加载
const tableLoading = ref(false);
// 总数量
const total = ref(0);
// 编辑的数据
const editData = ref({});
// 弹窗是否可见
const dialogVisible = ref(false);
// 创建时间排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const createTimeSort = ref(undefined);
// 排序排序规则 如果为undefined 则没有这个参数，如果为true代表倒叙，为false代表正序
const sortSort = ref(undefined);
// 选择的岗位
const selectSystemParams = ref([]);
// 全屏加载
const fullLoading = ref(false);
onMounted(async () => {
  await getSystemParamPage();
});
// 分页查询岗位
const getSystemParamPage = async () => {
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  tableLoading.value = true;
  const result = await request_systemparam_page(
    trans,
    () => (tableLoading.value = false)
  );
  total.value = result.total;
  tableData.value = result.rows;
  selectSystemParams.value = [];
  editData.value = {};
};

// 查询事件
const queryClick = () => {
  getSystemParamPage();
};
// 重置事件
const resetClick = () => {
  searchForm.dataflag = undefined;
  searchForm.inputSearch = "";
  getSystemParamPage();
};
// 处理页码大小改变事件
const handleSizeChange = (size) => {
  pageSize.value = size;
  getSystemParamPage();
};
// 处理当前页改变事件
const handleCurrentChange = (index) => {
  currentPage.value = index;
  getSystemParamPage();
};
// 处理编辑事件
const handleEdit = (type, data) => {
  let row = undefined;
  if (type === 1) {
    // 判断是否有且仅选择了一条用户数据
    if (selectSystemParams.value.length !== 1) {
      ElMessage.warning(t("Components.System.SystemParam.OnlyOneSelectEdit"));
      return;
    }
    row = selectSystemParams.value[0];
  } else if (type === 2) {
    row = data;
  }
  editData.value = {
    guid: row.guid,
    name: row.name,
    value: row.value,
    code: row.code,
    remark: row.remark,
    is_system: row.is_system,
  };
  dialogVisible.value = true;
};
// 处理回调关闭事件
const handleCloseDialog = () => {
  dialogVisible.value = false;
  editData.value = {};
  // selectSystemParams.value = [];
};
// 处理有效性改变事件
const handleDataflagChange = async (flag, row) => {
  await request_systemparam_dataflag(row.guid, true, () => {
    row.dataflag = !row.dataflag;
  });
};
// 处理选择回调事件
const handleSelectionChange = (systemParams) => {
  selectSystemParams.value = systemParams;
};
// 处理删除
const handleDelete = async (row) => {
  ElMessageBox.confirm(
    t("Components.System.SystemParam.ConfirmDeleteSystemParam"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      await request_systemparam_delete(row.guid, true);
      getSystemParamPage();
    })
    .catch(() => {});
};
// 批量删除
const handleDeleteBatch = async () => {
  if (selectSystemParams.value.length === 0) {
    ElMessage.warning(t("Components.System.SystemParam.AtLeastOneSystemParam"));
    return;
  }
  ElMessageBox.confirm(
    t("Components.System.SystemParam.ConfirmDeleteSystemParam"),
    t("Common.ElMessageBox.OperateConfirm"),
    {
      confirmButtonText: t("Common.ElMessageBox.ConfirmText"),
      cancelButtonText: t("Common.ElMessageBox.CancelText"),
      type: "warning",
      icon: markRaw(WarnTriangleFilled),
    }
  )
    .then(async () => {
      const trans = {
        guids: selectSystemParams.value.map((item) => item.guid),
      };
      await request_systemparam_delete_batch(trans, true);
      getSystemParamPage();
    })
    .catch(() => {});
};
// 处理排序改变事件
const handleSortChange = async ({ prop, order }) => {
  if (prop === "createtime") {
    sortSort.value = undefined;
    // 创建时间排序
    if (order === "ascending") {
      // 时间正序
      createTimeSort.value = false;
    } else if (order === "descending") {
      // 时间倒叙
      createTimeSort.value = true;
    } else {
      createTimeSort.value = undefined;
    }
  }
  await getSystemParamPage();
};
// 导出
const handleExport = async () => {
  fullLoading.value = true;
  const trans = {
    pagesize: pageSize.value,
    pageindex: currentPage.value,
    text: searchForm.inputSearch,
    dataflag: searchForm.dataflag,
    createTimeSort: createTimeSort.value,
    sort: sortSort.value,
  };
  const result = await request_systemparam_export(
    trans,
    true,
    () => (fullLoading.value = false)
  );
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = result;
  link.target = '_blank'
  document.body.appendChild(link);
  link.click();
};
watchEffect(() => {
  if (store.userMenus) {
    // 处理查询
    buttonVisible.searchButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamSearch
    );
    // 处理重置
    buttonVisible.resetButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamReset
    );
    // 处理新增
    buttonVisible.addButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamAdd
    );
    // 处理编辑
    buttonVisible.editButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamEdit
    );
    // 处理删除
    buttonVisible.deleteButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamDelete
    );
    // 处理删除行
    buttonVisible.editButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamEditLine
    );
    // 处理删除行
    buttonVisible.deleteButtonLine = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamDeleteLine
    );
    // 处理有效性
    buttonVisible.dataflag = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamDataflag
    );
    // 处理导出
    buttonVisible.exportButton = validateMenuButton(
      store.userMenus,
      MenuCodes.System.SystemParam,
      MenuButtonCodes.System.SystemParam.SystemParamExport
    );
  }
});
</script>
<style>
.systemparam-ul .el-scrollbar__view {
  height: calc(100% - 8px);
}
</style>
<style scoped lang="scss">
.systemparam-ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  height: 100%;
  .systemparam-li-search {
    // height: 100px;
  }
  .systemparam-li-page {
    // height: 100px;
    margin-top: 8px;
    box-sizing: border-box;
  }
}
</style>
